import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders, HttpParams } from '@angular/common/http';
import { API_URL } from '../Shared/constants/url.constants';
import { Observable } from 'rxjs';
import { ApiService } from '../Services/api.service';
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }
  getwebpage(): Observable<any> {
    const httpBody = new HttpParams()
      .set('RequestType', '2')
      .set('RecordCount', '3')
      .set('LegendType', '3');
    return this.http.post<any>(API_URL.BREAKOUT_WEBPAGE,httpBody);
  }
}
